export default __webpack_public_path__ + "static/media/orofacial-harmonization.c448554f.svg";